import { IconPlus } from "@synthesis/shared-icons";
import { Button } from "@synthesis/shared-ui";

import { SearchBar } from "../../../components/search-bar";
import { usePageStore } from "../constructor-services-page.lib";

/** Панель действий «Услуги»: поиск и кнопка новой услуги (модалка открывается через стор). */
export const ConstructorServicesToolbar = () => {
  const store = usePageStore()!;

  return (
    <div className="flex items-center justify-between gap-4">
      <SearchBar size="sm" clearable placeholder="Поиск по названию или коду" className="w-80 shrink-0" />
      <Button
        theme="primary"
        size="sm"
        leftIcon={<IconPlus className="size-5" aria-hidden />}
        onClick={() => store.setPopupAction({ type: "add-service" })}
      >
        Новая услуга
      </Button>
    </div>
  );
};
